export const revxScrollTo = (position: number, speed?: number) => {
  let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  const step = function () {
    const distance = position - scrollTop;
    scrollTop = scrollTop + distance / (speed || 5);
    if (Math.abs(distance) < 1) {
      // window.scrollTo(0, scrollTop + position);
    } else {
      window.scrollTo(0, scrollTop);
      requestAnimationFrame(step);
    }
  };
  step();
};
